import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import cn from 'classnames';
import Heading from '../../../components/Typography/Heading/Heading';
import StableTable from '../StableTable/StableTable';
import styles from './StableDetails.module.scss';
const StableDetails = ({ data, detailsTitle, className }) => (_jsxs("div", Object.assign({ className: cn(styles.element, className) }, { children: [detailsTitle && _jsx(Heading, { className: styles.heading, title: detailsTitle }), _jsx(StableTable, { data: data })] })));
export default StableDetails;
